import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer, { logoutSuccess } from "./authSlice";
import categoriesReducer from "./categories";
import questionsReducer from "./questions";
import subjectsReducer from "./subjects";
import positionsReducer from "./positions";
import departmentsReducer from "./departments";
import examsReducer from "./examsonline";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
};

const appReducer = combineReducers({
    auth: authReducer,
    categories: categoriesReducer,
    questions: questionsReducer,
    subjects: subjectsReducer,
    positions: positionsReducer,
    departments: departmentsReducer,
    exams: examsReducer
});

const rootReducer = (state, action) => {
    if (action.type === logoutSuccess.type) {
        // 👇 reset toàn bộ Redux state khi logout
        storage.removeItem('persist:root'); // clear localStorage redux-persist
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export let persistor = persistStore(store);
